module.exports = __webpack_public_path__ + "img/mp5sd.c881d6eb.svg";